export const OPTION_SELECTOR = '[aria-checked]';
export const SELECTED_OPTION_SELECTOR = '[aria-checked="true"]';

export const KEYS = {
  ACTIVATE: ['Enter', ' '],
  NEXT: ['ArrowRight', 'ArrowDown'],
  PREV: ['ArrowLeft', 'ArrowUp'],
  NEXT_HORIZONTAL: ['ArrowRight'],
  PREV_HORIZONTAL: ['ArrowLeft'],
  NEXT_VERTICAL: ['ArrowDown'],
  PREV_VERTICAL: ['ArrowUp'],
  INCREASE: ['ArrowRight', 'ArrowUp'],
  DECREASE: ['ArrowLeft', 'ArrowDown'],
  FIRST: ['Home'],
  LAST: ['End'],
  ESCAPE: ['Escape'],
  TAB: ['Tab']
};
